import { servicesConstants } from '../_constants';
let items = [];
let item = {};
const initialState = { loading: true, items, item };

export function subServices(state = initialState, action) {
	switch (action.type) {
		case servicesConstants.GET_SUB_REQUEST:
			return {
				...state,
				loading: true
			};
		case servicesConstants.GET_SUB_SUCCESS:
			return {
				...state,
				loading:false,
				item: ((action.subService!==null)?action.subService:{})
			};
		case servicesConstants.GET_SUB_FAILURE:
			return {
				...state,
				loading:false,
				error: action.error
			};
		case servicesConstants.GETALL_SUB_REQUEST:
			return {
				...state,
				loading: true
			};
		case servicesConstants.GETALL_SUB_SUCCESS:
			return {
				...state,
				loading:false,
				items: ((action.subServices!==null)?action.subServices:[]),
			};
		case servicesConstants.GETALL_SUB_FAILURE:
			return {
				...state,
				loading:false,
				error: action.error
			};
		default:
			return state
	}
}